import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import { TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useLocation } from 'react-router-dom';
import CheckoutLayoutItem from '../CheckoutLayoutItem';
import OrderPhone from '../OrderPhone';
import styles from './OrderEmail.style';
import useClasses from '../../../hooks/legacy/useClasses';
import { useUser } from '../../../hooks/useUser';

function OrderEmail({ onAdjustedValue, onCheckoutUpdating }) {
  const { phoneNumber } = useSelector(({ order }) => ({
    phoneNumber: order?.phone,
  }));
  const { userData } = useUser();
  const classes = useClasses(styles);

  const location = useLocation();
  const isCheckoutPage = location.pathname.includes('checkout');

  if (!userData) {
    return <CheckoutLayoutItem title="Contact Information" />;
  }

  return (
    <CheckoutLayoutItem title="Contact Information">
      {isCheckoutPage ? (
        <Stack direction="column" spacing={3}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <Stack
              direction="column"
              spacing={1}
              className={classes.buildingAddressWidth}
            >
              <Box>First Name</Box>
              <TextField
                defaultValue={userData.firstname}
                className={classes.inputColors}
                focused
                fullWidth
                disabled
              />
            </Stack>
            <Stack
              direction="column"
              spacing={1}
              className={classes.buildingAddressWidth}
            >
              <Box>Last Name</Box>
              <TextField
                defaultValue={userData.lastname}
                className={classes.inputColors}
                focused
                fullWidth
                disabled
              />
            </Stack>
          </Stack>
          <Stack direction="column" spacing={1}>
            <Box data-test-id="email-button">Email address</Box>
            <TextField
              defaultValue={userData.email}
              className={classes.inputColors}
              focused
              fullWidth
              disabled
            />
          </Stack>
          <Stack direction="column" spacing={1}>
            <Box>
              Phone Number
              <Box component="span" ml={1}>
                *
              </Box>
            </Box>
            <OrderPhone
              onAdjustedValue={onAdjustedValue}
              onCheckoutUpdating={onCheckoutUpdating}
            />
          </Stack>
        </Stack>
      ) : (
        <Stack direction="column" spacing={3}>
          <Box>
            <Typography fontWeight={500}>Name</Typography>
            <Typography color="text.secondary">
              {userData.firstname} {userData.lastname}
            </Typography>
          </Box>
          <Box>
            <Typography fontWeight={500} data-test-id="email-button">
              Email Address
            </Typography>
            <Typography color="text.secondary">{userData.email}</Typography>
          </Box>
          <Box>
            <Typography fontWeight={500}>Phone Number</Typography>
            <Typography color="text.secondary">{phoneNumber}</Typography>
          </Box>
        </Stack>
      )}
    </CheckoutLayoutItem>
  );
}

OrderEmail.propTypes = {
  onAdjustedValue: PropTypes.func,
  onCheckoutUpdating: PropTypes.bool.isRequired,
};

OrderEmail.defaultProps = {
  onAdjustedValue: null,
};

export default OrderEmail;
